import { FETCH_ADVANCED } from './constants';

export function fetchAdvanced() {
  return {
    type: FETCH_ADVANCED,
  };
}
